import {cs}                from "@Common/react/chain-services";

import {consumeContext}    from "@Common/react/context";
import {AGENT_LEVEL}       from "@Xpresso/routes/common/logic/user-level";
import {AccountLogosPanel} from "../../common/logos-panel/logos-panel"; 
import {ProfileLayout}     from "../common/profile-layout";

export const AccountLogosRoute = () => cs(
    consumeContext("userLevels"),
    consumeContext("session"),
    ({}, next) => ProfileLayout({activeTab: "logos", next}),
    ({userLevels, session}) => AccountLogosPanel({
        agentId: userLevels.userLevel === AGENT_LEVEL ? (
            session?.data?.agent?.idAgent
        ) : (
            null
        )
    }),
);
